





















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IStaffListRequest, IStaff } from "@/types/staff";
import { IContractorListRequest } from "@/types/contractor";
import { IPagination, ISelectItem } from "@/types";
import Search from "@/components/admin/forms/Search.vue";

@Component({
  components: {
    Search
  }
})
export default class extends Vue {
  @Action("staff/adminGetList")
  public adminGetList!: (request: IStaffListRequest) => boolean;

  @Action("contractor/adminGetList")
  public adminGetContractorList!: (params: IContractorListRequest) => void;

  @Getter("contractor/selectItem")
  public contractors!: ISelectItem[];

  @Getter("staff/list")
  public staffList!: IStaff[];

  @Getter("staff/pagination")
  public pagination!: IPagination<IStaff>;

  @Prop({ default: 0 })
  public fixed_contractor_id!: number;

  @Watch("$route.query")
  public async changeQuery() {
    this.queryToParams();
    await this.adminGetList(this.params);
  }

  @Mutation("staff/clear")
  public clear!: () => void;

  //
  // variables
  //
  public headers = [
    { text: "担当者名", value: "name", sortable: false },
    { text: "フリガナ", value: "kana", sortable: true },
    { text: "メモ", value: "note", sortable: false }
  ];
  public params: IStaffListRequest = {
    search: "",
    page: 1,
    contractor_id: 0
  };

  //
  // methods
  //
  public async created() {
    this.clear();
    this.queryToParams();

    if (this.fixed_contractor_id) {
      this.params.contractor_id = this.fixed_contractor_id;
    } else {
      this.headers.push({
        text: "元請け名",
        value: "contractor.name",
        sortable: false
      });
    }
    await Promise.all([
      this.adminGetList(this.params),
      this.adminGetContractorList({ per_page: 0 })
    ]);
  }

  // urlからパラメータをセットする
  // $router -> params
  private queryToParams() {
    const query = this.$route.query;
    this.params = {
      search: query.search ? decodeURI(query.search as string) : "",
      page: query.page ? Number(query.page) : 1
    };
    if (this.fixed_contractor_id) {
      this.params.contractor_id = this.fixed_contractor_id;
    }
  }

  // 1ページ目から検索
  // 主に検索条件が変更されたときに利用
  public async searchFirst() {
    this.params.page = 1;
    await this.paramsToQuery();
  }

  // URLのパラメータをセットする
  // params -> $router
  private paramsToQuery() {
    this.$router
      .push({
        path: this.$router.currentRoute.path,
        query: {
          search: this.params.search,
          page: this.params.page ? String(this.params.page) : "1"
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(() => {});
  }

  public rowClick(staff: IStaff) {
    this.$router.push(`/admin/staff/${staff.id}/edit`);
  }
}
